import { MediaRoot } from './ui/media.root';
import { MediaThumbnails } from './ui/media.thumbnails';
import { MediaUploader } from './ui/media.uploader';

export {
  createMediaFileFromAttachment,
  createMediaFileFromFile,
} from './domain/media-file.factory';

export type { MediaState, MediaOnChange } from './domain/media-file.types';
export type { MediaEvent } from './media.events';

export { useMediaState } from './hooks';

export const Media = {
  Root: MediaRoot,
  Uploader: MediaUploader,
  Thumbnails: MediaThumbnails,
};
